import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`To publish and install packages to and from the public npm registry or a private npm registry, you must install Node.js and the npm command line interface using either a Node version manager or a Node installer. `}<strong parentName="p">{`We strongly recommend using a Node version manager like `}<a parentName="strong" {...{
          "href": "https://github.com/nvm-sh/nvm"
        }}>{`nvm`}</a>{` to install Node.js and npm.`}</strong>{` We do not recommend using a Node installer, since the Node installation process installs npm in a directory with local permissions and can cause permissions errors when you run npm packages globally.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` to download the latest version of npm, on the command line, run the following command:`}</p>
      <pre><code parentName="pre" {...{}}>{`npm install -g npm
`}</code></pre>
    </Note>
    <h2>{`Overview`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#checking-your-version-of-npm-and-node-js"
        }}>{`Checking your version of npm and Node.js`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#using-a-node-version-manager-to-install-node-js-and-npm"
        }}>{`Using a Node version manager to install Node.js and npm`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#using-a-node-installer-to-install-node-js-and-npm"
        }}>{`Using a Node installer to install Node.js and npm`}</a></li>
    </ul>
    <h2>{`Checking your version of npm and Node.js`}</h2>
    <p>{`To see if you already have Node.js and npm installed and check the installed version, run the following commands:`}</p>
    <pre><code parentName="pre" {...{}}>{`node -v
npm -v
`}</code></pre>
    <h2>{`Using a Node version manager to install Node.js and npm`}</h2>
    <p>{`Node version managers allow you to install and switch between multiple versions of Node.js and npm on your system so you can test your applications on multiple versions of npm to ensure they work for users on different versions.`}</p>
    <h3>{`OSX or Linux Node version managers`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/creationix/nvm"
        }}>{`nvm`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/tj/n"
        }}>{`n`}</a></li>
    </ul>
    <h3>{`Windows Node version managers`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/marcelklehr/nodist"
        }}>{`nodist`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/coreybutler/nvm-windows"
        }}>{`nvm-windows`}</a></li>
    </ul>
    <h2>{`Using a Node installer to install Node.js and npm`}</h2>
    <p>{`If you are unable to use a Node version manager, you can use a Node installer to install both Node.js and npm on your system.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://nodejs.org/en/download/"
        }}>{`Node.js installer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/nodesource/distributions"
        }}>{`NodeSource installer`}</a></li>
    </ul>
    <p>{`If you use Linux, we recommend that you use a NodeSource installer.`}</p>
    <h3>{`OS X or Windows Node installers`}</h3>
    <p>{`If you're using OS X or Windows, use one of the installers from the `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/download/"
      }}>{`Node.js download page`}</a>{`. Be sure to install the version labeled `}<strong parentName="p">{`LTS`}</strong>{`. Other versions have not yet been tested with npm.`}</p>
    <h3>{`Linux or other operating systems Node installers`}</h3>
    <p>{`If you're using Linux or another operating system, use one of the following installers:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/nodesource/distributions"
        }}>{`NodeSource installer`}</a>{` (recommended)`}</li>
      <li parentName="ul">{`One of the installers on the `}<a parentName="li" {...{
          "href": "https://nodejs.org/en/download/"
        }}>{`Node.js download page`}</a></li>
    </ul>
    <p>{`Or see `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/download/package-manager/"
      }}>{`this page`}</a>{` to install npm for Linux in the way many Linux developers prefer.`}</p>
    <h3>{`Less-common operating systems`}</h3>
    <p>{`For more information on installing Node.js on a variety of operating systems, see `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/download/package-manager/"
      }}>{`this page`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      